import {mediaQueries} from 'src/theme/mediaQueries'
import styled, {css} from 'styled-components'

export const StyledNavigateAlert = styled.div(
    ({theme: {colors, spacing}}) => css`
        background-color: ${colors.bgYellow};
        padding: ${spacing * 3}px 0;
        & > div {
            display: grid;
            grid-template-columns: 1fr auto;
            align-items: center;
            gap: ${spacing * 3}px;
            ${mediaQueries.m} {
                grid-template-columns: 1fr;
                & a {
                    width: 100%;
                }
            }
        }
    `
)

export const StyledTextWrapper = styled.div(
    () => css`
        display: flex;
        flex-direction: column;
    `
)

export const StyledLeftSideWrapper = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 3}px;
        align-items: center;
        height: 100%;
    `
)

export const StyledSubText = styled.p(
    ({theme: {colors, typography}}) => css`
        ${typography.textXs};
        color: ${colors.lightBlack};
        font-weight: 500;
    `
)

export const StyledMainText = styled.h3(
    ({theme: {colors, typography}}) => css`
        ${typography.textMd};
        color: ${colors.darkYellow};
        font-weight: 500;
    `
)
